import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CANCEL_BTN, QA_NAME_EXPORT_BTN } from '../../../constants/qa'
import { useNotification } from '../../../hooks'
import { postApi } from '../../../utils/api'
import Button from '../../Button'
import Modal, { Box, Buttons, Header } from '../../Modal'

import { QA_NAME_MODAL_EXPORT_INVOICE } from './RequestExportInvoiceModal.constants'

import * as styles from './RequestExportInvoiceModal.module.css'

function RequestExportInvoiceModal({ onClose, onSubmit }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const [isLoading, setLoading] = useState(false)

  function handleApply() {
    setLoading(true)

    postApi({ endpoint: 'api/budget-plan/export/' })
      .then(() => {
        onSubmit()
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  return (
    <Modal qaName={QA_NAME_MODAL_EXPORT_INVOICE} onClose={onClose}>
      <Box>
        <Header
          text={t('Modal.ExportInvoiceAttentionTitleKey')}
          onClose={onClose}
        />
        <div className={styles.message}>
          {t('Request.ExportInvoiceAttentionTextKey')}
        </div>
        <Buttons>
          <Button.Contained
            isLoading={isLoading}
            qaName={QA_NAME_EXPORT_BTN}
            text={t('Modal.ExportInvoiceBtnKey')}
            onClick={handleApply}
          />
          <Button.Outlined
            className={styles.btn}
            qaName={QA_NAME_CANCEL_BTN}
            text={t('Modal.CancelBtnKey')}
            onClick={onClose}
          />
        </Buttons>
      </Box>
    </Modal>
  )
}

export default RequestExportInvoiceModal
